export interface RateStackResponseRate {
  error: boolean;
  selected: boolean;
  daily_base_rate: number;
  displayed_loan_rate: number;
  price_delta: number;
  points_or_credits: number;
  monthly_payment: number;
  dti: number;
}

export interface RateStackResponse {
  loan_amount: number;
  locked: boolean;
  rate_stack: RateStackResponseRate[];
}

/** For taking RateStackResponses emitted by the API and parsing any decimal values from strings. */
export const parseRateStackResponse = (resp: any): RateStackResponse => ({
  ...resp,
  loan_amount: Number(resp.loan_amount),
  rate_stack: resp.rate_stack.map((rate: any) => ({
    ...rate,
    daily_base_rate: Number(rate.daily_base_rate),
    displayed_loan_rate: Number(rate.displayed_loan_rate),
    price_delta: Number(rate.price_delta),
    points_or_credits: Number(rate.points_or_credits),
    monthly_payment: Number(rate.monthly_payment),
    dti: Number(rate.dti),
  })),
});
